import { API_BASE_URL } from "../services/api";

/** HTTP(S) API base → WS(S) base (same rules as mobile realtimeApi). */
function wsBaseFromHttp(baseUrl: string): string {
  return baseUrl.replace(/^https:\/\//i, "wss://").replace(/^http:\/\//i, "ws://");
}

/** Base URL for WebSocket: same host as the page when API is same-origin. */
export function getWebSocketBase(): string {
  if (typeof window !== "undefined") {
    const pageProto = window.location.protocol === "https:" ? "wss:" : "ws:";
    const pageBase = `${pageProto}//${window.location.host}`;
    const api = (API_BASE_URL || "").replace(/\/$/, "");
    if (!api) return pageBase;
    try {
      if (new URL(api).host === window.location.host) return pageBase;
    } catch {
      /* invalid VITE_API_BASE_URL */
    }
    return wsBaseFromHttp(api);
  }
  const api = (API_BASE_URL || "").replace(/\/$/, "");
  return api ? wsBaseFromHttp(api) : "";
}
